// oxlint-disable react/jsx-pascal-case
import * as React from 'react'
import * as BasePhoneInput from 'react-phone-number-input'
import { cn } from '../../lib/utils'
import { Input } from './input'

type PhoneInputProps = Omit<React.ComponentProps<'input'>, 'onChange' | 'value' | 'ref'> &
  Omit<
    BasePhoneInput.Props<typeof BasePhoneInput.default>,
    'onChange' | 'variant' | 'popupClassName' | 'scrollAreaClassName'
  > & {
    onChange?: (value: BasePhoneInput.Value) => void
  }

function PhoneInput({ className, onChange, value, ...props }: PhoneInputProps) {
  return (
    <BasePhoneInput.default
      className={cn('flex w-full', className)}
      inputComponent={Input}
      smartCaret={false}
      value={value}
      international
      defaultCountry="FR"
      countryCallingCodeEditable={false}
      countrySelectComponent={() => <div />}
      onChange={(value) => onChange?.(value || ('' as BasePhoneInput.Value))}
      {...props}
    />
  )
}

export { PhoneInput }
